import "highcharts/modules/drilldown";

import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useEffect, useState } from "react";

export const BookingtopFacilites = ({ data }: any) => {
  const [options, setOptions] = useState<Highcharts.Options>({});
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (!data) return;

    const mobile = typeof window !== "undefined" && window.innerWidth < 768;
    setIsMobile(mobile);

    const maxDays = 30;
    const drilldownCategories = Array.from({ length: maxDays }, (_, i) =>
      (i + 1).toString()
    );

    const mainSeriesData = data.items.map((month: any) => ({
      name: month.Name,
      y: month.BookingValue ?? 0,
      revenue: month.RevenueValue ?? 0,
      drilldown:
        data.drilldown?.length > 1 && month.BookingValue > 0
          ? month.Name
          : null,
      FacilityName: month.FacilityName,
      sportName: month.SportName,
    }));

    const drilldownMap = new Map<number, any>();
    data.drilldown?.forEach((day: any) => {
      drilldownMap.set(Number(day.Name), day);
    });

    const drilldownSeries: Highcharts.SeriesOptionsType[] =
      data.drilldown?.length > 1
        ? data.items
            .filter((item: any) => item.BookingValue > 0)
            .map((month: any) => {
              const drillData = drilldownCategories.map((day) => {
                const dayNum = Number(day);
                const drillItem = drilldownMap.get(dayNum);

                return {
                  name: day,
                  y: drillItem?.BookingValue ?? 0,
                  revenue: drillItem?.RevenueValue ?? 0,
                  FacilityName: drillItem?.FacilityName,
                  sportName: drillItem?.SportName,
                };
              });

              return {
                id: month.Name,
                name: `${month.Name} Details`,
                data: drillData,
                type: "column",
              };
            })
        : [];

    const chartOptions: Highcharts.Options = {
      chart: {
        type: "column",
        ...(isMobile && {
          scrollablePlotArea: {
            minWidth: data.items.length * 80,
            scrollPositionX: 0,
          },
        }),
      },
      title: {
        text: "Top facilities (Bookings + Revenue)",
        align: isMobile ? "left" : "center", // Responsive alignment
        style: {
          fontSize: "13px",
        },
      },
      xAxis: {
        type: "category",
        labels: {
          step: 1,
          style: {
            fontSize: "11px",
          },
        },
      },
      yAxis: {
        title: { text: "Total Booking" },
      },
      legend: { enabled: false },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: false,
            style: {
              fontSize: "10px",
              textOutline: "none",
            },
            y: -10,
          },
        },
      },
      tooltip: {
        useHTML: true,
        formatter: function (this: any) {
          return `
            <b>Facility:</b> ${this.point.FacilityName}<br/>
            <b>Sport:</b> ${this.point.sportName} <br/>
            <b>Booking:</b> ${this.point.y}<br/>
            <b>Revenue:</b> KD ${this.point.revenue}
          `;
        },
      },
      credits: { enabled: false },
      series: [
        {
          name: "Facilities",
          colorByPoint: true,
          type: "column",
          data: mainSeriesData,
        },
      ],
      ...(drilldownSeries.length > 0 && {
        drilldown: {
          series: drilldownSeries,
        },
      }),
    };

    setOptions(chartOptions);
  }, [data]);

  return (
    <div
      style={{
        overflowX: isMobile ? "auto" : "visible",
        overflowY: "hidden", // ✅ prevents vertical scroll
      }}
    >
      <div
        style={{
          minWidth: isMobile ? `${data.items.length * 80}px` : "100%",
        }}
      >
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    </div>
  );
};
